import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { Strings } from '@app/constants';
import { DetailsCard } from '@app/components/card';
import { getLeaveManagement, selectLeaveManagementState } from '@app/modules/leave-setting';
import { ILeaveSchema } from '../types';

interface Props {
  userData: ILeaveSchema;
}
export const LeaveInfo = ({ userData }: Props) => {
  const dispatch = useDispatch();
  const leaveState = useSelector(selectLeaveManagementState);

  const leaveTypeCounts: Record<string, number> = {};
  userData?.leaves?.map((leave) => {
    const leaveType = leave.leaveType.toLowerCase();
    leave.periods.forEach((period) => {
      if (period.period === 'Full Day') {
        leaveTypeCounts[leaveType] = (leaveTypeCounts[leaveType] || 0) + 1;
      } else if (period.period.includes('Half')) {
        leaveTypeCounts[leaveType] = (leaveTypeCounts[leaveType] || 0) + 0.5;
      }
    });
    return leaveTypeCounts;
  });

  useEffect(() => {
    dispatch(getLeaveManagement());
  }, [dispatch]);

  const fields = leaveState?.data?.map((leave) => leave.leaveType.toLowerCase()) ?? [];

  const data =
    leaveState?.data?.map((leave) => {
      const leaveType = leave.leaveType.toLowerCase();
      const leaveCount = leaveTypeCounts[leaveType] || 0;
      return `${leaveCount}`;
    }) ?? [];

  return (
    <DetailsCard
      title={Strings.profile.leaveInformation}
      fields={fields}
      data={data}
      height={'270px'}
      iconImg="ic_leave"
    />
  );
};
